import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import RTGSTransactionsTable from '../components/RTGSTransactionsTable';
interface RTGSTransactionsProps {
  onLogout: () => void;
}
const RTGSTransactions: React.FC<RTGSTransactionsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-5009">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="RTGS Transactions" data-id="element-5010" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="rtgs" data-id="element-5011" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: 0
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-5012">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-5013">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-5014">
            <Icon icon="lucide:building-2" width={28} height={28} color="#8B5CF6" data-id="element-5015" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-5016">
              RTGS Transactions
            </Typography>
          </Box>
          <RTGSTransactionsTable data-id="element-5017" />
        </Box>
      </Box>
    </Box>;
};
export default RTGSTransactions;